// Helper Functions

export function replaceUrl(url) {
    return url.replace(process.env.REACT_APP_URL, '');
}
